import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import Input from "../common/Input";
import Select from "../common/Select";
import { censusServices } from "../services/soar";

function ServiceModal({ isOpen, handleClose, updateServices }) {
  const [data, setData] = useState({});

  const handleSave = async () => {
    const resp = await censusServices({
      command: "insert",
      application:
        process.env.REACT_APP_ENVIRONMENT === "Production"
          ? "5dae139e-d052-4bd8-bf4a-499a31ac3c15"
          : "58990f83-8566-4ba8-b4b5-584a64e4cba1",
      name: data.name,
      type: data.type,
    });
    if (resp.code === "success") {
      updateServices();
      setData({});
      handleClose();
    } else {
      toast.warning(`There was a problem with saving Service. ${resp.message}`);
    }
  };

  return (
    <Modal show={isOpen} onHide={handleClose} animation={false} size="lg">
      <Modal.Header closeButton className="bg-safy-info text-white">
        <Modal.Title>Group Plan</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Input
          name="name"
          label="Service Name"
          value={data.name}
          onChange={(e) => {
            setData({ ...data, name: e.target.value });
          }}
        />
        <Select
          name="type"
          label="Type"
          type="select"
          value={data.type}
          options={[{ _id: "Census", name: "Census" }]}
          onChange={(e) => {
            setData({ ...data, type: e.target.value });
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <div className="btn btn-danger" onClick={handleClose}>
          Close
        </div>
        <div
          className="btn btn-success"
          onClick={() => {
            handleSave();
          }}
        >
          Save
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ServiceModal;
